import react, { useEffect } from "react";
import { useParams } from "react-router-dom";

const PaymentDirect = () => {

    const { twilio_conversation_id } = useParams();
    
    const API_URL = process.env.REACT_APP_API_URL;
   
    const handleError = (error) => {
        window.location.replace("/error?error="+error);
        return false;
    };

    const getCustomerInfo = async () => {
        try {
            const aResponse = await fetch(`${API_URL}/conversations/customer-info`, {
                method: "POST",
                headers: {
                "Content-Type": "application/json"
                },
                body: JSON.stringify({ 
                    e_ph: localStorage.getItem("p"),
                    twilio_conversation_id: twilio_conversation_id
                })
            });
            if (aResponse.status !== 200) {
                console.error("Failed to get customer info");
                handleError("Failed to get customer info");
                return false;
            }
            const data = await aResponse.json();
            return data?.customerInfo;
        } catch (error) {
            console.error("Error getting customer info:", error);
            handleError("Failed to get customer info");
            return false;
        }
    };

    useEffect(() => {
        if(twilio_conversation_id) {
            Promise.resolve(getCustomerInfo()).then((customerInfo) => {
                if(customerInfo) {
                    const e_ph = customerInfo?.weakly_encrypted_phone_number || "";
                    window.location.replace(`/t/${twilio_conversation_id}/pay/${e_ph}/standard?lang=english`, "_self");
                } else {
                    console.error("No customer info found");
                    handleError("no_customer_info");
                }
            });
        } else {
            console.error("No Twilio conversation ID provided");
            handleError("no_twilio_conversation_id");
        }
    }, [twilio_conversation_id]);

    return (
        <div>
            <img src="https://buckish-ghosted-maps.s3.us-west-1.amazonaws.com/boggler-logo-clear.webp" alt="Boggler Logo" className="pulsing-boggler-logo" style={{ width: "120px", height: "auto", margin: "20px auto", display: "block" }} />
        </div>
    );
}

export default PaymentDirect;